import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Robot(props: PresetArtProps) {
  return (
    <PresetFrame background="#475569" {...props}>
      <path d="M32 21 V13" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
      <circle cx="32" cy="12" r="3.5" fill="#ffffff" />
      <rect x="17" y="21" width="30" height="25" rx="5" fill="#ffffff" />
      <rect x="12" y="29" width="5" height="9" rx="2" fill="#ffffff" />
      <rect x="47" y="29" width="5" height="9" rx="2" fill="#ffffff" />
      <circle cx="26" cy="31" r="3.5" fill="#1f2937" />
      <circle cx="38" cy="31" r="3.5" fill="#1f2937" />
      <rect x="25" y="38" width="14" height="3" rx="1.5" fill="#1f2937" />
    </PresetFrame>
  );
}
